import cookie from 'cookie';
import I18N from '@discordapp/i18n';

import type enMessages from './messages/en-US.json';

// This is duplicated to polyfill Intl for Safari and older browsers
require('intl');

// https://github.com/prettier/prettier/issues/5584
const i18n = new I18N<typeof enMessages>({
  initialLocale: cookie.parse(document.cookie).locale,
  getMessages: (locale) => {
    return require(`./messages/${locale}`);
  },
  getLanguages: () => require('./languages.json'),
});

i18n.addListener('locale', (locale) => {
  // set to root path, or possible to set locale on just a subdirectory
  document.cookie = `locale=${locale};path=/`;
});

export default i18n;
